<template>
  <!-- THE ONE SEASON MENU, as a list inside a popover: the type's seasons × the
       next three years, the current choice checked. Pick = acts (the caller
       writes); no second button. -->
  <ul class="min-w-48" role="listbox" data-testid="season-choices">
    <li v-for="choice in choices" :key="choice.key">
      <button
        type="button"
        role="option"
        :aria-selected="choice.key === selectedKey"
        class="flex w-full items-center justify-between gap-3 rounded px-2.5 py-1.5 text-left text-sm hover:bg-sunken"
        :class="choice.key === selectedKey ? 'font-semibold' : ''"
        :data-testid="`season-choice-${choice.key}`"
        @click="emit('pick', choice)"
      >
        <span>{{ choice.label }}</span>
        <Check v-if="choice.key === selectedKey" class="h-4 w-4 text-state-ink" />
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { Check } from 'lucide-vue-next'
import type { SeasonChoice } from '@/lib/seasons'

defineProps<{ choices: SeasonChoice[]; selectedKey: string | null }>()
const emit = defineEmits<{ pick: [choice: SeasonChoice] }>()
</script>
